import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { LifeCycleStageFormValues } from './AddLifeCycleStageFormWrapper';


type Props = {
  formikProps: FormikProps<LifeCycleStageFormValues>;
  onClose: () => void;
};

const AddLifeCycleStageForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className='p-4 flex flex-col gap-6'>
      <div className='flex justify-between items-center'>
        <div className='text-xl font-medium'>Add  Life Cycle</div>
        <button type='button' className='hover:bg-hover' onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className='flex flex-col gap-4'>
        <div>
          <ATMTextField
            name='stageName'
            value={values.stageName}
            onChange={(e) => {
              setFieldValue('stageName', e.target.value);
            }}
            label='Stage Name'
            placeholder='Enter Stage Name'
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type='submit'>
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default AddLifeCycleStageForm;